<form [formGroup]="formGroup">
	<ng-container *ngIf="!loading">
		<div class="d-flex flex-column">
			<div class="d-flex pb-3">
				<mat-form-field appearance="outline" *ngIf="isAnswer" class="w-25 mail-field me-2">
					<mat-label>Wysłano z</mat-label>
					<input matInput disabled value="" />
				</mat-form-field>
				<ng-container *ngIf="!isAnswer">
					<section class="d-flex flex-column justify-content-center pe-2">
						<mat-checkbox color="primary" formControlName="assignAllParticipants">
							Wyślij do wszytkich uczestników
						</mat-checkbox>
						<mat-checkbox *ngIf="sellerMail" color="primary" formControlName="sellerSend"
							>Agent: {{ sellerMail }}
						</mat-checkbox>
					</section>
					<mat-form-field appearance="outline" class="mail-field w-50 me-2">
						<mat-label>Do</mat-label>
						<input
							type="email"
							matInput
							[matAutocomplete]="autoUser"
							formControlName="addressee"
							(input)="setAddresseeFromInput($event)"
						/>
						<mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selectUser($event)">
							<mat-option *ngFor="let user of filteredUsers" [value]="user.userContacts[0].email">
								{{ user.userContacts[0].email }}
								<span class="text-xs">({{ user.firstName }} {{ user.lastName }})</span>
							</mat-option>
						</mat-autocomplete>
						<mat-error>Nieprawidłowy adres e-mail</mat-error>
					</mat-form-field>
				</ng-container>
				<mat-form-field class="w-25 mail-field" appearance="outline">
					<mat-select placeholder="Szablon" formControlName="template">
						<mat-option
							*ngFor="let document of documentForMail"
							(click)="selectTemplate()"
							[value]="document.name"
							>{{ document.displayName }}</mat-option
						>
					</mat-select>
				</mat-form-field>
				<button class="w-25 ms-2 mt-2" color="accent" (click)="attachmentsUpload.click()" mat-raised-button>
					<input #attachmentsUpload multiple (change)="addAttachments($event)" class="d-none" type="file" />
					<i class="fa-solid fa-file-circle-plus"></i> Dodaj załączniki
				</button>
			</div>

			<ng-container *ngIf="!isAnswer">
				<mat-form-field appearance="outline" class="w-100 pb-3 mail-field">
					<mat-label>Tytuł</mat-label>
					<input matInput formControlName="subject" type="text" name="subject" />
					<mat-error>Pole wymagane</mat-error>
				</mat-form-field>
				<mat-progress-bar class="w-50" *ngIf="userLoading" mode="indeterminate"></mat-progress-bar>
			</ng-container>
		</div>
		<div style="max-height: 500px; overflow: auto">
			<angular-editor class="email-editor" [config]="editorConfig" formControlName="message"></angular-editor>
			<div
				style="width: fit-content; max-width: 60%; border: 1px solid #ddd; font-size: 12px"
				class="py-1 px-3 my-2 text-secondary rounded-3 d-flex align-items-center"
				*ngFor="let attachment of attachments; let i = index"
			>
				<div role="button" class="me-2" (click)="downloadAddedAttachment(attachment)">
					{{ attachment.filename }}
					<span style="font-size: 10px"
						>({{ attachment?.size | bytesConversion: FileSizeUnit.KILOBYTES }})</span
					>
				</div>
				<button (click)="removeAttachment(i)" mat-icon-button color="primary">
					<i class="fas fa-times"></i>
				</button>
			</div>
		</div>
	</ng-container>
	<div *ngIf="loading" class="w-100 d-flex justify-content-center align-items-center" style="height: 400px">
		<mat-spinner></mat-spinner>
	</div>
	<div class="mt-3 text-end">
		<button *ngIf="isAnswer" mat-raised-button class="closeButton" (click)="closeAnswer.emit()" color="primary">
			<i class="fas fa-trash"></i>
		</button>
		<button
			(click)="checkSend(); closeAnswer.emit()"
			class="ms-2 send-btn"
			mat-raised-button
			[disabled]="formGroup.invalid"
			color="primary"
		>
			Wyślij<i class="fas fa-paper-plane ps-1"></i>
		</button>
	</div>
</form>
